/* Built In Imports */
import { useEffect, useState } from 'react';

/* External Imports */
import { Box } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import WrapLayout from '@Layout/WrapLayout';
import ProgramTabSection from 'landing_pages/sadhgurusannidhi/ProgramTabSection';
import Breadcrum from '@components/Navigation/Breadcrum';
import StructuredTextContent from '@components/UI/StructuredTextContent';
import HeadComponent from '@components/Utility/HeadComponent';
import config from '@config';
import Banner from 'landing_pages/sadhgurusannidhi/Banner';
import DoubtsClarify from 'landing_pages/sadhgurusannidhi/DoubtsClarify';
import HowSannidhi from 'landing_pages/sadhgurusannidhi/HowSannidhi';
import ProgrmDetail from 'landing_pages/sadhgurusannidhi/ProgarmDetail';
import ProgrmDetails from 'landing_pages/sadhgurusannidhi/ProgarmDetails';
import SannidhiFaq from 'landing_pages/sadhgurusannidhi/SannidhiFaq';
import SannidhiSpace from 'landing_pages/sadhgurusannidhi/SannidhiSpace';
import SannidhiTestimonial from 'landing_pages/sadhgurusannidhi/SannidhiTestimonial';

/* Services */
import { getLocale } from '@components/Utility/Shared/SharedService';
import {
  fetchFooterData,
  fetchHeaderMenuData,
  fetchHeaderTopMenuData,
  filterBuildUrls,
  getLatestBuild,
} from 'services/commonService';
import {
  fetchDetails,
  fetchSannidhiGeoContentData,
} from 'services/sadhgurusannidhi';
import { BuildConstants } from '../../../../../../constants';

/* Styles */

/**
 * @param {string} region - Current User Region
 * @param {string} language - Current User Language
 * @param {string} pageData - Inner Engineering Online Landingpage Data
 */
const SadhguruSannidhi = ({ pageData, region, language }) => {
  const [programData, setProgramData] = useState('');

  const uiSection = {
    HEADERBANNER: 'banner',
    HOWSANNIDHI: 'how-sannidhi-program',
    TESTIMONIALS: 'testimonials',
    PROGRAMDETAIL: 'program-type',
    PROGRAMDETAILS: 'program-details',
    EVENTPROGRAMDETAIL: 'event-program-tab-section',
    SANNIDHISPACE: 'sannidhi-space',
    FAQ: 'faq',
    FAQN: 'faq-note',
    DOUBTSCLARIFIED: 'doubts-clarified',
  };

  useEffect(() => {
    localData();
  }, []);

  const localData = async () => {
    let programData = await fetchSannidhiGeoContentData(region, language);
    // let programData = {
    //   jsonrpc: '2.0',
    //   id: null,
    //   result: [
    //     {
    //       id: 32,
    //       name: 'Sadhguru Sannidhi Sangha',
    //       url_registration:
    //         'https://preprod-online.sadhguru.org/event-register?event=sadhguru-sannidhi-sangha-32',
    //       url_enquiry:
    //         'https://preprod-online.sadhguru.org/program-lead?event_type=sadhguru-sannidhi-sangha-online&disable_program_selection=true',
    //       start_date: '2023-04-12 11:30:00',
    //       end_date: '2023-05-18 13:30:00',
    //       seats_available: 99999,
    //       max_per_booking: 6,
    //       tickets: [
    //         {
    //           id: 56,
    //           name: 'Champa',
    //           seats_available: 99999,
    //           start_date: false,
    //           end_date: false,
    //           price: 750.0,
    //           currency: 'GBP',
    //           person_count: 1,
    //           is_expired: false,
    //         },
    //       ],
    //       batches: [],
    //       venue: {
    //         street: false,
    //         street_2: false,
    //         city: false,
    //         state: false,
    //         country: false,
    //         country_code: false,
    //         zip: '641114',
    //       },
    //       regional_support_email: 'https://support.ishayoga.eu',
    //       regional_support_phone: false,
    //       regional_notes:
    //         'Price Includes Program Fee, Sannidhi and Shipping Cost',
    //       is_registration_allowed: true,
    //       queried_country_code: 'GB',
    //     },
    //   ],
    // };
    setProgramData(programData);
    // console.log('data1', programData);
  };
  // console.log('data2', programData);

  const renderCenterContent = () => {
    return pageData?.body?.map((section, i) => {
      switch (section.sectionId) {
        case uiSection.HEADERBANNER:
          return (
            <Banner
              pageBody={section.sectionContent}
              region={region}
              language={language}
            />
          );
        case uiSection.HOWSANNIDHI:
          return (
            <HowSannidhi
              section={section.sectionContent}
              region={region}
              language={language}
            />
          );
        case uiSection.TESTIMONIALS:
          return (
            <SannidhiTestimonial
              pageBody={section.sectionContent}
              region={region}
              language={language}
            />
          );
        case uiSection.PROGRAMDETAILS:
          return <ProgrmDetails pageBody={section.sectionContent} />;
        case uiSection.PROGRAMDETAIL:
          return <ProgrmDetail pageBody={section.sectionContent} />;
        case uiSection.EVENTPROGRAMDETAIL:
          return (
            <ProgramTabSection
              section={section.sectionContent}
              lang={language}
              styling={section}
              csrData={programData}
            />
          );
        case uiSection.SANNIDHISPACE:
          return <SannidhiSpace pageBody={section.sectionContent} />;
        case uiSection.FAQ:
          return <SannidhiFaq pageBody={section.sectionContent} />;
        case uiSection.FAQN:
          return (
            <Box
              as="div"
              width={{ base: '90%', sm: '90%', md: '700px' }}
              m={{ base: '10px auto 15px auto', md: '20px auto 15px auto' }}
              fontSize={{ base: '14px', md: '16px' }}
              lineHeight="27px"
              textAlign="left"
              position="relative"
              top="-25px"
            >
              {StructuredTextContent(section.sectionContent[0]?.body)}
            </Box>
          );
        case uiSection.DOUBTSCLARIFIED:
          return (
            <DoubtsClarify
              section={section.sectionContent}
              region={region}
              language={language}
              csrData={programData}
            />
          );
        default:
          break;
      }
    });
  };

  return (
    <WrapLayout>
      <HeadComponent
        data={pageData?._seoMetaTags || pageData?.seoFields}
        availableLocals={pageData?.availableLocales}
      ></HeadComponent>
      <Breadcrum
        page={pageData?.breadcrumbs}
        alsoin={pageData?.alsoin}
        url=""
        region={region}
        lang={language}
        pageConfig={pageData?.pageConfig}
      />
      <Box
        as="section"
        maxW="1300px"
        mx="auto"
        fontFamily="FedraSansStd-book, sans-serif"
        color="#28231E"
      >
        {renderCenterContent()}
      </Box>
      <style global jsx>
        {`
          .event-text a {
            color: #cf4824;
          }
          .centercontent a:hover {
            text-decoration: none;
          }
          .text-underline a {
            text-decoration: underline;
          }
          .text-underline.orange {
            color: #cf4520;
            padding-top: 16px;
          }
          .event-text a {
            font-size: 14px;
          }
        `}
      </style>
    </WrapLayout>
  );
};

export const getStaticPaths = async () => {
  let ieoLandingPaths =
    config.USE_LOCAL_URL || config.BUILD_URLS?.LANDING_PAGES?.SadhguruSannidhi
      ? [
        `/in/en/events/special-events/sadhguru-sannidhi`,
        `/us/en/events/special-events/sadhguru-sannidhi`,
        `/global/en/events/special-events/sadhguru-sannidhi`,
        `/uk/en/events/special-events/sadhguru-sannidhi`,
        `/au/en/events/special-events/sadhguru-sannidhi`,
        `/sg/en/events/special-events/sadhguru-sannidhi`,
        `/my/en/events/special-events/sadhguru-sannidhi`,
      ]
      : [];

  if (process.env?.NEXT_PUBLIC_BUILD_ID) {
    let data = await getLatestBuild(process.env.NEXT_PUBLIC_BUILD_ID);
    ieoLandingPaths = filterBuildUrls(
      `${BuildConstants.section.landing_pages}`,
      `${BuildConstants.level.L2}`,
      '/events/special-events/sadhguru-sannidhi',
      '',
      data
    );
    // debugger;
    // consoleLog('sadhguru-sannidhi url data', process.env.NEXT_PUBLIC_BUILD_ID, data, ieoLandingPaths);
  }
  return {
    paths: ieoLandingPaths,
    fallback: false,
  };
};

export const getStaticProps = async ({
  preview,
  previewData,
  params: { region, language },
  req,
}) => {
  const headerTopMenuData = await fetchHeaderTopMenuData(
    getLocale(region, language),
    'isotopmenu'
  );
  const headerMenuData = await fetchHeaderMenuData(
    getLocale(region, language),
    'isomainmenu'
  );
  const footerData = await fetchFooterData(
    getLocale(region, language),
    'isofooter'
  );
  const pageData = await fetchDetails(region, language);
  return {
    props: {
      headerTopMenuData: headerTopMenuData?.data || null,
      headerMenuData: headerMenuData?.data || null,
      region: region,
      language: language,
      footerData: footerData?.data || null,
      pageData: pageData || null,
      page: 'Sannidhi',
    },
  };
};

export default SadhguruSannidhi;
